




























import { stringToNumber } from "@/utility/CommonHelper";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class FrekuensiNadi extends Vue {
  @Prop() setNadi: number = null;
  @Prop() setLabel!: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Ref() readonly inputElement: HTMLInputElement;
  @Prop({ default: () => [] }) errorMessages?: string[];

  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [v => this.cek(v) || this.message()];

  maxLimit = 300;

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (!this.setNadi) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setNadi")
  valNadi(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }

    this.setNadi = val;

    this.$emit("frekNadi", val);
  }

  cek(v) {
    this.setNadi = stringToNumber(v);

    if ((typeof v === "number" || v instanceof Number) && v > this.maxLimit) {
      this.msg = "*Frekuensi Nadi " + v + ", Anda yakin?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }

  focus() {
    this.inputElement.focus();
  }
}
